import { siteStats } from "@/mocks/movieData";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20dark%20theater%20interior%20with%20dramatic%20warm%20red%20and%20amber%20light%20beams%2C%20film%20projector%20glow%2C%20subtle%20grain%20texture%2C%20deep%20shadows%2C%20moody%20atmospheric%20stylized%20illustration%2C%20no%20text&width=1920&height=1080&seq=shenma-hero-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/75"></div>

      <div className="relative z-10 w-full">
        <div className="mx-auto w-full max-w-6xl px-4 md:px-6 pt-28 md:pt-40 pb-14 md:pb-24">
          <div className="max-w-3xl animate-fade-up">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/12 text-background-100 text-xs md:text-sm font-label backdrop-blur">
              <span className="w-2 h-2 rounded-full bg-accent-400"></span>
              观影入口导航 · 说明与整理
            </span>

            <h1 className="mt-5 font-heading text-3xl md:text-5xl font-black text-background-50 leading-tight">
              神马电影官网入口
              <span className="block mt-2 text-2xl md:text-4xl font-bold text-accent-300">
                最新地址 · 网址导航 · APP 下载
              </span>
            </h1>

            <p className="mt-5 text-sm md:text-lg text-background-100 leading-relaxed max-w-2xl">
              这个页面把神马电影相关的入口信息整理到一起：官网入口在哪、地址失效时怎么换、手机端和电脑端分别怎么用、需不需要装 APP。
              你不需要在搜索结果的陌生链接里反复试探，先从下面选一条线路开始即可。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="#lines"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-label whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-link-m" aria-hidden="true"></i>
                查看最新地址与线路
              </a>
              <a
                href="#entry"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50 text-foreground-950 text-sm md:text-base font-label whitespace-nowrap hover:bg-background-100 transition-colors cursor-pointer"
              >
                <i className="ri-compass-3-line" aria-hidden="true"></i>
                我该从哪里开始
              </a>
            </div>
          </div>

          <dl className="mt-12 md:mt-16 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
            {siteStats.map((stat) => (
              <div
                key={stat.id}
                className="rounded-lg bg-white/10 backdrop-blur border border-white/15 px-4 py-3 md:py-4"
              >
                <dt className="text-xs md:text-sm text-background-200 font-label">{stat.label}</dt>
                <dd className="mt-1 flex items-baseline gap-1 text-background-50">
                  <span className="font-heading text-2xl md:text-3xl font-bold">{stat.value}</span>
                  {stat.unit ? <span className="text-sm text-background-200">{stat.unit}</span> : null}
                </dd>
                <p className="mt-1 text-[11px] md:text-xs text-background-300 hidden sm:block">{stat.note}</p>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}